export const DATE_RANGE_MAX_DAYS = 60
